(function () {
    'use strict';

    angular.module('components.wizard', [
        'components.form',
        'components.warning',
        'mgo-angular-wizard'
    ]);
})();